// import { ClassValue, clsx } from "clsx";
// import { twMerge } from "tailwind-merge";

// Use cn() instead of classNames() in future to enable
// tailwind class name overrides (and it's shorter to type)
export function classNames(
  ...classes: (string | boolean | null | undefined)[]
): string {
  return classes.filter(Boolean).join(" ");
}

export const cn = classNames;

// See https://twitter.com/shadcn/status/1614692419039105024
// and https://github.com/dcastil/tailwind-merge/blob/v1.9.1/docs/features.md
// export function cn(...inputs: ClassValue[]) {
//   return twMerge(clsx(inputs));
// }
